<div [formGroup]="form">
  <label class="radio-label-padding">{{item.label}}: </label>
  <mat-radio-group [formControlName]="item.name" [required]="item.required">
    <mat-radio-button *ngFor="let opt of item.options" [value]="opt.data">{{opt.label|translate}}&nbsp;</mat-radio-button>
  </mat-radio-group>
</div>